<div class="spinner_overlay"></div>

<rl-spinner class="spinner text-primary-medium" [diameter]="72"></rl-spinner>
